import React from 'react'
import OperacionesPedidosCalado from '../components/OperacionesPedidosCalado'
import moment from 'moment'

export function getColumnasPedidosCamiones (rolAutorizado = false) {
  return ([
    {
      name: 'fechaDePedido',
      label: 'Fecha de pedido',
      options: {
        filter: false,
        sort: true,
        customBodyRender: (fecha) => {
          return <>{moment(fecha).format('DD-MM-YYYY HH:mm')}</>
        }
      }
    },
    {
      name: 'calleDeBruto',
      label: 'Calle de bruto',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'
      }
    },
    {
      name: 'cereal',
      label: 'Cereal',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox'

      }
    },
    {
      name: 'caravana',
      label: 'Silo aparte',
      options: {
        filter: true,
        sort: true,
        filterType: 'checkbox',
        customBodyRender: (caravana) => {
          return <>{caravana ? 'No' : 'Si' }</>
        }
      }
    },
    {
      name: 'calificacionCereal',
      label: 'Calificación',
      options: {
        filter: true,
        sort: true,
        filterType: 'multiselect',
        customBodyRender: (c) => {
          return <>{c || ' - ' }</>
        }
      }
    },
    {
      name: 'cantidad',
      label: 'Cantidad',
      options: {
        filter: false,
        sort: true,
        total: true
      }
    },
    {
      name: 'pendientes',
      label: 'Restan',
      options: {
        filter: false,
        sort: true,
        total: true,
        customBodyRender: (p) => {
          return <b>{p}</b>
        }
      }
    },
    {
      name: 'fechaDePedido',
      label: ' ',
      options: {
        print: false,
        filter: false,
        sort: false,
        customBodyRender: value => {
          return rolAutorizado && <OperacionesPedidosCalado fecha={value} />
        }
      }
    }
  ])
}

export const COLUMNS_PEDIDO_CAMIONES_EN_CALADO_TO_PRINT = [
  {
    name: 'fechaDePedido',
    label: 'Fecha de pedido',
    width: 150,
    mantenerCase: true
  },
  {
    name: 'cereal',
    label: 'Cereal',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'calificacionCereal',
    label: 'Calificación cereal',
    width: 120,
    mantenerCase: true
  },
  {
    name: 'cantidad',
    label: 'Cantidad',
    width: 60,
    mantenerCase: true
  },
  {
    name: 'restantes',
    label: 'Restan',
    width: 60,
    mantenerCase: true
  }
]
